import React, { forwardRef, useImperativeHandle } from 'react';
import { useState } from 'react';

export default function Modal(props, ref) {
    const [modalState, setModalState] = useState(false)
    let showModal = (showModal) => {
        setModalState(showModal);
        if (!showModal) {
           props.setTabState('image'); 
        }
    }
    useImperativeHandle(ref, () => ({
        showModal
    }));
    return (
        <>
            <div className='gemini-modal-backdrop' style={{display: !modalState ? 'none' : 'block'}} onClick={() => {showModal(false)}}>
            </div>
            <div className='gemini-modal-overlay' style={{display: !modalState ? 'none' : 'flex', width: props.width || '', maxWidth: props.maxWidth || '' }}>
                {props.children}
            </div>
        </>
    );
}
Modal = forwardRef(Modal);